document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.first-button').forEach(function(button) {
    button.addEventListener('click', function() {
      document.querySelectorAll('.animated-icon1').forEach(function(icon) {
        icon.classList.toggle('open');
      });
    });
  });
});

const animationDuration = 3000;

const frameDuration = 1000 / 60;

const totalFrames = Math.round(animationDuration / frameDuration);

const easeOutQuad = (t) => t * (2 - t);

const animateCountUp = (el) => {
  let frame = 0;
  const countTo = parseInt(el.innerHTML, 10);

  const counter = setInterval(() => {
    frame++;

    const progress = easeOutQuad(frame / totalFrames);

    const currentCount = Math.round(countTo * progress);

    if (parseInt(el.innerHTML, 10) !== currentCount) {
      el.innerHTML = currentCount;
    }

    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};

const countupEls = document.querySelectorAll(".timer");

if ('IntersectionObserver' in window) {
  const countObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      animateCountUp(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.3 });

  countupEls.forEach(function(el) {
    countObserver.observe(el);
  });
} else {
  countupEls.forEach(animateCountUp);
}

// Owl Carousel initialization is handled in individual section files
// This prevents conflicts with specific slider configurations

 

document.addEventListener('DOMContentLoaded', function() {
  var filterButtons = document.querySelectorAll('.filter-button');
  var filterItems = document.querySelectorAll('.filter');

  if (!filterButtons.length || !filterItems.length) return;

  filterButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var value = button.getAttribute('data-filter');

      filterButtons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      button.classList.add('active');

      filterItems.forEach(function(item) {
        var shouldShow = value === 'all' || item.classList.contains(value);
        item.style.display = shouldShow ? '' : 'none';
      });
    });
  });
});
